import kbwServiceImage from './kundenservice-kommunales-bildungswerk.jpg'
import { useAppSelector } from '../../redux/_reduxHooks.tsx'

export const EventGoalsAccordion = () => {
  const webEventTopicData = useAppSelector((state) => state.web.selectedNwTopic)
  return (
    <>
      <div className="container-fluid">
        <div className="row bg4s">
          <div className="container seminarsec" style={{ marginBottom: '80px' }}>
            <div className="row bgwhi" style={{ borderRadius: '0.6em' }}>
              <div className="" style={{ margin: '0 15px' }}>
                <div className="col-xs-12 sec1">
                  <section className="acContent-container">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-xs-12 text-justify">
                          <div className="row">
                            <div className="accouter">
                              <input id="acZiel" name="acZiel" type="checkbox" defaultChecked />
                              <h2>
                                <label htmlFor="acZiel">Ziel</label>
                              </h2>
                              <div className="acZiel-small acContent-small">
                                {webEventTopicData?.seminarList[0].einleitungstext}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  <div className="">
                    <section className="acContent-container">
                      <div className="col-xs-12">
                        <div className="row">
                          {webEventTopicData?.seminarList[0].zielgruppe &&
                            <>
                              <div className="accouter">
                                <input id="acZielgruppe" name="acZielgruppe" type="checkbox" defaultChecked />
                                <h2>
                                  <label htmlFor="acZielgruppe">Zielgruppe</label>
                                </h2>
                                <div className="acZielgruppe-small acContent-small">
                                  {webEventTopicData?.seminarList[0].zielgruppe}
                                </div>
                              </div>
                            </>
                          }
                        </div>
                      </div>
                    </section>
                  </div>
                  <section className="acContent-container">
                    <div className="col-md-12 col-xs-12">
                      <div className="row">
                        {webEventTopicData?.seminarList[0].arbeitsmittel &&
                        <div className="accouter">
                          <input id="acArbmittel" name="acArbmittel" type="checkbox" defaultChecked />
                          <h2>
                            <label htmlFor="acArbmittel">Mitzubringende Arbeitsmittel</label>
                          </h2>
                          <div className="acArbmittel-small acContent-small">
                            <p className="">keine</p>
                          </div>
                        </div>}
                      </div>
                    </div>
                  </section>
                  <div className="">
                    <section className="acContent-container">
                      <div className="">
                        <div className="">
                          <div className="col-xs-12">
                            <div className="row">
                              <div className="accouter border0">
                                <input id="acAnsprech" name="acAnsprech" type="checkbox" defaultChecked />
                                <h2>
                                  <label htmlFor="acAnsprech">Beratung</label>
                                </h2>
                                <div className="acContent-small acAnsprech-small">
                                  <div className="col-xs-12 col-md-6">
                                    <div className="row">
                                      <div className="col-xs-12 col-md-4">
                                        <div className="organi">
                                          <div className="tagungsOrga">
                                            <div className="orgaBild">
                                              <div className="hovereffect col-center" style={{ borderRadius: '0.6em' }}>
                                                <img className="img-responsive" src={kbwServiceImage} alt="Kundenservice KBW e. V." width="220px" height="247px" />
                                                <div className="overlay">
                                                  <a className="info" href="../service" title="Unser Kundenservice macht es möglich. Fordern Sie uns!"></a>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-xs-12 col-md-8">
                                        <div className="orga">
                                          <p>
                                            <b>Organisatorische Fragen</b> zu freien Teilnehmerplätzen, Anreise, Hotelbuchungen, etc. beantwortet Ihnen unser Kundenservice.
                                          </p>
                                          <div className="orgaTel text-left">
                                            Telefon: <span className="lead">(030) 29 33 50 0</span>
                                          </div>
                                          <div className="orgaMail text-left">
                                            E-Mail:
                                            <a href="mailto:info@kbw.de" rel="nofollow">
                                              info@kbw.de
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xs-12 col-md-6">
                                    <div className="row">
                                      {/*//ToDo*/}
                                      {/* <div className="col-xs-12 col-md-4">
                                        <div className="organi">
                                          <div className="tagungsOrga">
                                            <div className="orgaBild">
                                              <div className="hovereffect col-center" style={{ borderRadius: '0.6em' }}>
                                                <img className="img-responsive" src="" title="TODO: NAME" width="220px" height="294px" alt="Bild -TODO: NAME" />
                                                <div className="overlay">
                                                  <a className="info " href="todo" title="Zum Mitarbeiterprofil">
                                                    <span className="sr-only">Zum Profil Ihres Ansprechpartners</span>
                                                  </a>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-xs-12 col-md-8">
                                        <div className="orga">
                                          <p>
                                            Für <b>inhaltliche Fragen</b> steht Ihnen <a href="/ueber-uns/team/bereich-konzeptentwicklung/christine-lahde">Frau Christine Lahde</a> gern zur Verfügung.
                                          </p>
                                          <div className="orgaMail text-left">
                                            <a
                                              href="/ueber-uns/team/bereich-konzeptentwicklung/christine-lahde?ThmCode=KAI005S#kformmitarbeiter"
                                              className="btn btn-r btn-sm btn-default"
                                              title="Kontaktformular zum/zur KBW e.V.- Mitarbeiter:in"
                                            >
                                              Kontaktformular
                                            </a>
                                          </div>
                                        </div>
                                      </div> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xs-12 padt-1"></div>
        </div>
      </div>
    </>
  )
}
